import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation, withRouter } from "react-router-dom";
import moment from "moment";
import "moment/locale/it";

// @material-ui/icons
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";

import checkCardNumber from "api/checkCardNumber";
import getMuseum from "api/getMuseum";
import pathSplit from "util/pathSplit";
import CustomProfilingForm from "./customProfilingForm";

function isEmpty(value) {
  //return value === "" || value === null || value === undefined;
  return value === null || value === undefined;
}

const useStyles = makeStyles(styles);

function VisitorInformation(props) {
  const {
    item,
    productId,
    index,
    updateVisitorInformation,
    customStyle,
    setCardError,
  } = props;
  const classes = useStyles();

  const [tempCard, setTempCard] = useState("");
  const [cardErrorMessage, setCardErrorMessage] = useState("");
  const [hasCards, setHasCards] = useState(false);

  const [nameError, setNameError] = useState(false);
  const [surnameError, setSurnameError] = useState(false);

  let location = useLocation();

  const { id } = pathSplit(
    location && location.pathname ? location.pathname : "",
    ""
  );

  const museumId = id;

  const [org, setOrg] = useState();

  useEffect(() => {
    getMuseum(museumId).then((response) => {
      setOrg(response.organization);
      if (response.organization?.tesseres.length > 0) {
        setHasCards(true);
      }
    });
  }, [museumId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const { t } = useTranslation();

  function dateInPast(firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    function checkCard(tempCard) {
      //not cardNumber
      if (tempCard !== "") {
        checkCardNumber(tempCard)
          .then((response) => {
            if (response.length > 0) {
              if (dateInPast(new Date(), new Date(response[0].scadenza))) {
                setCardErrorMessage("");
                setCardError(false, tempCard);
              } else {
                setCardErrorMessage(
                  t("userInformation.error_card_expired") +
                    moment(new Date(response[0].scadenza)).format("DD/MM/YYYY")
                );
                setCardError(true, tempCard);
              }
            } else {
              setCardErrorMessage(t("userInformation.error_card_inexistent"));
              setCardError(true, tempCard);
            }
          })
          .catch((errors) => {
            if (errors.statusCode === 401 || errors.statusCode === 403) {
              this.props.history.push("/");
            }
          });
      } else {
        setCardErrorMessage("");
        setCardError(false);
      }
    }

    if (!isEmpty(tempCard)) {
      const delayDebounceFn = setTimeout(() => {
        checkCard(tempCard);
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempCard]);

  return (
    <CardBody style={{ marginTop: 5 }}>
      <div
        style={{
          position: "absolute",
          top: 3,
          left: 0,
          fontSize: "13px",
          height: "20px",
          width: "20px",
          borderRadius: "10px",
          border: "1px solid rgb(200,200,200)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {index + 1}
      </div>

      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            marginTop: 5,
            marginRight: "10px",
          }}
        >
          <p
            style={{
              margin: 10,
              marginLeft: 0,
              fontSize: 12,
              textAlign: "left",
            }}
          >
            {t("userInformation.name") + "*"}
          </p>
          <input
            type="text"
            style={{
              borderRadius: 5,
              border: nameError ? "1px solid #B33030" : "1px solid lightgray",
              width: "100%",
              height: 40,
              textAlign: "left",
              outline: "none",
              padding: 10,
              boxSizing: `border-box`,
            }}
            value={item?.visitatore?.nome || ""}
            onChange={(e) => {
              updateVisitorInformation(
                productId,
                index,
                "nome",
                e.target.value
              );
              if (e.target.value === "") {
                setNameError(true);
              } else {
                setNameError(false);
              }
            }}
            placeholder={t("userInformation.name")}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            marginTop: 5,
            marginLeft: "10px",
          }}
        >
          <p
            style={{
              margin: 10,
              marginLeft: 0,
              fontSize: 12,
              textAlign: "left",
            }}
          >
            {t("userInformation.surname") + "*"}
          </p>
          <input
            type="text"
            style={{
              borderRadius: 5,
              border: surnameError
                ? "1px solid #B33030"
                : "1px solid lightgray",
              width: "100%",
              height: 40,
              textAlign: "left",
              outline: "none",
              padding: 10,
              boxSizing: `border-box`,
            }}
            value={item?.visitatore?.cognome || ""}
            onChange={(e) => {
              updateVisitorInformation(
                productId,
                index,
                "cognome",
                e.target.value
              );
              if (e.target.value === "") {
                setSurnameError(true);
              } else {
                setSurnameError(false);
              }
            }}
            placeholder={t("userInformation.surname")}
          />
        </div>
      </div>
      <CustomProfilingForm
        tickets={1}
        customProfiling={item?.visitatore?.additional_info}
        update={(value) => {
          updateVisitorInformation(productId, index, "additional_info", value);
        }}
        org={org}
      />
    </CardBody>
  );
}

VisitorInformation.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  productId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  updateVisitorInformation: PropTypes.func.isRequired,
  customStyle: PropTypes.object,
};

VisitorInformation.defaultProps = {
  cartUnique: {},
  customStyle: {},
};

export default withRouter(VisitorInformation);
